import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ResourceRequester } from "sulu-admin-bundle/services";
import SingleItemSelection from "sulu-admin-bundle/components/SingleItemSelection";

const leftButton = {
    icon: "su-document",
};

const shortenFileName = (name) => {
    if (!name) return "";

    if (name.length <= 15) return name;

    const start = name.slice(0, 8);
    const end = name.slice(-6);
    return `${start}...${end}`;
};

const CustomMediaReadonly = ({ value, formInspector, router }) => {
    const mediaId = value?.id;
    const locale = formInspector?.locale?.value || router?.attributes?.locale;
    const [media, setMedia] = useState(null);
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();
    const emptyTranslation = t("sulu_admin.passports.documents");

    useEffect(() => {
        if (!mediaId) return;

        const fetchMedia = async () => {
            setLoading(true);
            try {
                const data = await ResourceRequester.get("media", {
                    id: mediaId,
                    locale: locale,
                });
                setMedia(data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchMedia();
    }, []);

    return (
        <div>
            <SingleItemSelection
                emptyText={emptyTranslation}
                leftButton={leftButton}
                disabled={true}
                loading={loading}
            >
                {media && (
                    <a
                        href={`${media?.url}&inline=1`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {shortenFileName(media?.name)}
                    </a>
                )}
            </SingleItemSelection>
        </div>
    );
};

export default CustomMediaReadonly;
